module.exports = __webpack_public_path__ + "static/media/icon_extension_png.1db8a863.svg";